export default __webpack_public_path__ + "media/images/theme/m_logo_light-7963ac123a404debb35375c5106737f4.png";